import React, { useState } from 'react'
import UpdateForm from './UpdateForm';
import { Typography } from '@mui/material';
import { Modal } from 'react-bootstrap'

export default function RolesSetup() {
    const [lgShow, setLgShow] = useState(false);

    return (
        <>
            <div className="container mt-1">
                <div className="p-5 bg-light rounded shadow-sm">
                    <div className="row">
                        <div className="row my-1 ">
                            <div className="col-md-6">
                                <Typography className="mx-3" variant='h4' sx={{ pb: 1 }}>
                                    Access Setup
                                </Typography>
                            </div>

                            <div className="col-md-6 d-flex justify-content-end">
                               
                            </div>
                        </div>
                    </div>

                    <UpdateForm />
                </div>
            </div>
        </>
    );
}
